
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDistanceToNow } from 'date-fns';
import { Product } from '@/types/portfolio';

interface ProductInformationProps {
  product: Product;
}

export const ProductInformation = ({ product }: ProductInformationProps) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Product Information</CardTitle>
        <CardDescription>Basic details about this product</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h4 className="font-medium text-sm text-muted-foreground mb-1">SKU Number</h4>
            <p>SKU-{product.id.slice(0, 8).toUpperCase()}</p>
          </div>
          
          <div>
            <h4 className="font-medium text-sm text-muted-foreground mb-1">Format</h4>
            <p>Liquid Spray</p>
          </div>
          
          <div>
            <h4 className="font-medium text-sm text-muted-foreground mb-1">Packaging</h4>
            <p>32 oz Recyclable Plastic Bottle</p>
          </div>
          
          <div>
            <h4 className="font-medium text-sm text-muted-foreground mb-1">Product Type</h4>
            <p className="capitalize">{product.product_type}</p>
          </div>
        </div>
        
        <div>
          <h4 className="font-medium text-sm text-muted-foreground mb-1">Description</h4>
          <p>{product.description || "No description provided"}</p>
        </div>
        
        {product.manufacturer && (
          <div>
            <h4 className="font-medium text-sm text-muted-foreground mb-1">Manufacturer</h4>
            <p>{product.manufacturer}</p>
          </div>
        )}
        
        <div>
          <h4 className="font-medium text-sm text-muted-foreground mb-1">Last Updated</h4>
          <p>{formatDistanceToNow(new Date(product.updated_at), { addSuffix: true })}</p>
        </div>
      </CardContent>
    </Card>
  );
};
